/* eslint-disable jsx-a11y/anchor-is-valid */
import clsx from 'clsx'
import {useState} from 'react'
import {KTIcon} from '../../../../helpers'
import {useLayout} from '../../../core'

const ToolbarClassic = () => {
  const {config} = useLayout()

  return (

    <div className='d-flex align-items-center gap-2 gap-lg-3'>
    </div>
  )
}

export {ToolbarClassic}
